"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductClass = void 0;
const common_1 = require("../../common");
class ProductClass extends common_1.MongoDocument {
}
exports.ProductClass = ProductClass;
//# sourceMappingURL=product-class.model.js.map